// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Kiribati from '../_raw/flag/icon_flag_kiribati.png';

export default () => <img src={Kiribati} alt="Kiribati" />;
